'use client';

import Link from 'next/link';
import { ArrowRight, X } from 'lucide-react';
import { useState } from 'react';

export const MegaMenuResourcesContent = ({ menuItems }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalToggle = (event) => {
    event.preventDefault(); // Prevent default link behavior
    setModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="grid grid-cols-5 gap-2">
        {/* Left Section */}
        <div className="h-[460px] px-3 py-8 bg-[#fcfcff] col-span-3">
          <div className="h-[360px] grid grid-cols-2 gap-1">
            {menuItems.map((item, index) => (
              <a
                href={item.href}
                key={index}
                className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
              >
                <div className="items-center gap-2">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6">{item.icon}</div>
                    <div className="mega-menu-submenu-title">{item.title}</div>
                  </div>
                  <div className="mega-menu-submenu-text">{item.description}</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Right Section */}
        <div className="h-[460px] px-6 py-8 bg-[#f3f4f8] col-span-2 pt-11 flex flex-col justify-between">
          <div>
            <p className="mega-menu-featured-content-title mb-4">
              Lifetime mortgage FAQs - applications and bankruptcy
            </p>
            <p className="resources-featured-content-text mb-6">
              Watch our FAQ videos for quick answers.
            </p>
            <Link
              href="https://www.youtube.com/@pureretirement7964/videos"
              className="resources-featured-content-text-link inline-flex items-center"
              target="_blank"
            >
              Visit FAQs <ArrowRight className="w-4 h-4 ml-1"/>
            </Link>
          </div>
          {/* Video Link */}
          <div className="relative w-full h-[200px] mt-4 rounded-lg">
            <div onClick={handleModalToggle}>
              <img
                src="/img/adviser/homepage/stats-1.webp"
                alt="Placeholder"
                loading="lazy"
                className="object-cover rounded-lg h-[200px] w-full"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <img src="/img/icons/play_button.svg" alt="Placeholder" loading="lazy" className="w-20 h-20" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 h-[100vh] lg:-mt-6 xl:-mt-3.5">
          <div className="relative w-full max-w-2xl -mt-40">
            {/* Close Button */}
            <button
              onClick={handleModalToggle}
              className="absolute -top-10 right-1 p-1 text-gray-600 hover:text-gray-900"
            >
              <X className="w-10 h-10 text-white" />
            </button>
            {/* Video Content */}
            <div className="w-full aspect-video">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/5FEU3X-C7Yg?si=jNpsUl8urpppbosM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
              </iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
